<template>
  <div v-show="visiable" ref="popper" :class="prefixCls" :style="styles">
    <div :class="[prefixCls + '-arrow']"></div>
    <div :class="[prefixCls + '-content']">
      <div v-if="showTitle" :class="[prefixCls + '-title']">
        <slot name="title" class="title">
          <div :class="[prefixCls + '-title-inner']">{{ title }}</div>
        </slot>
      </div>
      <div :class="[prefixCls + '-inner']">
        <div v-if="showContent" :class="[prefixCls + '-body']">
          <div :class="[prefixCls + '-body-content']">
            <slot name="content">
              <div :class="[prefixCls + '-body-content-inner']">{{ content }}</div>
            </slot>
          </div>
        </div>
        <div v-if="confirm" :class="[prefixCls + '-footer', 'text-right']">
          <t-popper-button :cancel-text="cancelText" :confirm-text="confirmText" v-on="$listeners" @on-cancel="$_onPopperClose" @on-confirm="$_onPopperClose"></t-popper-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TPopperButton from './popper-button'
import { PREFIX_CLASS } from '../../utils/constants'
const PREFIXCLS = `${PREFIX_CLASS}popover`
export default {
  name: 'TPopper',
  components: {
    TPopperButton
  },
  props: {
    visiable: {
      type: Boolean,
      default: false
    },
    transitionName: {
      type: String,
      default: 'fade'
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    confirm: {
      type: Boolean,
      default: false
    },
    confirmText: {
      type: String,
      default: ''
    },
    cancelText: {
      type: String,
      default: ''
    },
    showTitle: {
      type: Boolean,
      default: false
    },
    showContent: {
      type: Boolean,
      default: false
    },
    // eslint-disable-next-line
    width: {
      type: [String, Number]
    }
  },
  data () {
    return {
      prefixCls: PREFIXCLS,
      model: false
    }
  },
  computed: {
    styles () {
      let style = {}

      if (this.width) {
        style.width = `${this.width}px`
      }
      return style
    },
    getPopNode () {
      return this.$refs.popper
    }
  },
  methods: {
    $_onPopperClose () {
      this.$emit('update:visiable', false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/poptip/popper.vue